const typo = {
  fontSize: {
    small: "16px",
    normal: "16px",
    large: "16px",
  },
  fontWeight: {
    light: "300",
    normal: "400",
    bold: "600",
    thick: "800",
  },
  fontFamily: {
    basic: "sans-serif",
  },
};

export default typo;
